import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const EnhancedProjectsHeader = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section enhanced-header projects-header" style={{
      backgroundColor: '#1a1a1a',
      color: 'white',
      paddingTop: '10rem',
      paddingBottom: '8rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="blob" style={{ top: '-20%', right: '-10%', opacity: 0.2 }}></div>
      <div className="blob" style={{ bottom: '-30%', left: '-15%', opacity: 0.2 }}></div>
      <div className="bg-pattern"></div>
      
      {/* Project icons decoration */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '50%',
        opacity: 0.1,
        zIndex: 1,
        backgroundImage: 'none',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom center',
        backgroundSize: 'contain'
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="grid" style={{ gridTemplateColumns: 'repeat(12, 1fr)', gap: '2rem' }}>
          <div className="col-span-8 md-col-span-12">
            <h1 className="hero-title enhanced-header-title fade-in" style={{ 
              fontSize: '3.5rem',
              marginBottom: '1rem',
              background: 'linear-gradient(90deg, #ffffff, #FF9A40)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent'
            }}>
              {t('projects.title')}
            </h1>
            
            <p className="enhanced-header-subtitle fade-in" style={{ 
              fontSize: '1.25rem',
              color: 'rgba(255, 255, 255, 0.9)',
              maxWidth: '800px',
              marginBottom: '2rem'
            }}>
              {language === 'fr' 
                ? 'Découvrez nos projets réussis et études de cas dans le secteur Pétrole, Gaz et Industrie.'
                : language === 'ar' 
                ? 'اكتشف مشاريعنا الناجحة ودراسات الحالة في قطاع النفط والغاز والصناعة.'
                : 'Discover our successful projects and case studies in the Oil, Gas and Industry sector.'}
            </p>
            
            <div className="project-tags projects-tags fade-in" style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1rem',
              marginTop: '2rem'
            }}>
              <div style={{ 
                backgroundColor: 'rgba(255, 107, 0, 0.2)',
                color: 'white',
                padding: '0.5rem 1.5rem',
                borderRadius: 'var(--radius-full)',
                fontSize: '0.9375rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                {language === 'fr' ? 'Pétrole et gaz' : 
                 language === 'ar' ? 'النفط والغاز' : 
                 'Oil & Gas'}
              </div>
              
              <div style={{ 
                backgroundColor: 'rgba(255, 107, 0, 0.2)',
                color: 'white',
                padding: '0.5rem 1.5rem',
                borderRadius: 'var(--radius-full)',
                fontSize: '0.9375rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
                {language === 'fr' ? 'Chimie' : 
                 language === 'ar' ? 'الكيمياء' : 
                 'Chemical'}
              </div>
              
              <div style={{ 
                backgroundColor: 'rgba(255, 107, 0, 0.2)',
                color: 'white',
                padding: '0.5rem 1.5rem',
                borderRadius: 'var(--radius-full)',
                fontSize: '0.9375rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                {language === 'fr' ? 'Production d\'énergie' : 
                 language === 'ar' ? 'توليد الطاقة' : 
                 'Power generation'}
              </div>
              
              <div style={{ 
                backgroundColor: 'rgba(255, 107, 0, 0.2)',
                color: 'white',
                padding: '0.5rem 1.5rem',
                borderRadius: 'var(--radius-full)',
                fontSize: '0.9375rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {language === 'fr' ? 'Fabrication' : 
                 language === 'ar' ? 'التصنيع' : 
                 'Manufacturing'}
              </div>
            </div>
          </div>
          
          <div className="col-span-4 md-col-span-12 fade-in" style={{ animationDelay: '0.3s' }}>
            <div style={{
              position: 'relative',
              height: '100%',
              minHeight: '300px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {/* Project animation */}
              <div className="project-container" style={{
                position: 'relative',
                width: '250px',
                height: '250px'
              }}>
                <div className="project-circle" style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '180px',
                  height: '180px',
                  borderRadius: '50%',
                  background: 'radial-gradient(circle, rgba(255, 107, 0, 0.3) 0%, rgba(255, 107, 0, 0) 70%)',
                  animation: 'pulse 3s infinite'
                }}></div>
                
                <div className="project-inner" style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 107, 0, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: '700',
                  fontSize: '1.25rem',
                  boxShadow: '0 0 30px rgba(255, 107, 0, 0.3)'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '60px', height: '60px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                
                <div className="project-small" style={{
                  position: 'absolute',
                  top: '20%',
                  right: '10%',
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 215, 0, 0.2)',
                  animation: 'float 4s ease-in-out infinite'
                }}></div>
                
                <div className="project-small" style={{
                  position: 'absolute',
                  bottom: '20%',
                  left: '10%',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 215, 0, 0.2)',
                  animation: 'float 3s ease-in-out infinite 1s'
                }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Shape Divider - Smooth Mobile Wave */}
      <div className="shape-divider" style={{ transform: 'rotate(180deg)' }}>
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <defs>
            <filter id="smooth-projects" colorInterpolationFilters="sRGB">
              <feGaussianBlur in="SourceGraphic" stdDeviation="0.5"/>
            </filter>
          </defs>
          <path d="M0,0V46.29c47.79,22.4,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" className="shape-fill"></path>
        </svg>
      </div>
      
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.3;
          }
          50% {
            transform: translate(-50%, -50%) scale(1.1);
            opacity: 0.5;
          }
          100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.3;
          }
        }
        
        @keyframes float {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default EnhancedProjectsHeader;
